import axios from "axios";
import { User } from "oidc-client";
import { getUserManager } from "@axa-fr/react-oidc-context";
import LocalStorageService from "./LocalStorageService";

const FaraGostarDynamicHttp = async () => {
    let userPersonCode = LocalStorageService.getUserPersonCode();

    const um = (await getUserManager().getUser()) as User;
    const token = um.access_token;

    let headers = null;
    if (token) {
        headers = {
            Authorization: `Bearer ${token}`,
        };
    }

    const instance = axios.create({
        baseURL: window.config.apiUrl + userPersonCode + "/",
        headers,
    });

    return instance;
};

export default FaraGostarDynamicHttp;
